import { Layout, Section } from 'layout';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import CrmBrandTradeLicenseMappingsListScreen from './screens/crm-brand-trade-license-mappings-list-screen';

const CrmBrandTradeLicenseMappingsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={CrmBrandTradeLicenseMappingsListScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default CrmBrandTradeLicenseMappingsPage;
